import useLanguageStore from '@stores/languageStore';
import { Helmet } from 'react-helmet-async';

const SchemaMarkup = () => {
  const { language } = useLanguageStore();

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: {
      he: 'אבני חן מצבות ואנדרטאות עמוס גנאח בע״מ',
      en: 'Avne Chen Tombstones and Memorials Amos Ganah Ltd.',
    }[language],
    description: {
      he: 'קבלן מצבות מקצועי מאז 1981. בניית מצבות, חידוש מצבות ואנדרטאות במחיר מפעל עם 40 שנות אחריות.',
      en: 'Professional tombstone contractor since 1981. Tombstone construction, renewal and memorials at factory price with 40 years warranty.',
    }[language],
    telephone: '03-5331294',
    email: 'avnechen@walla.com',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    image: [
      `${typeof window !== 'undefined' ? window.location.origin : ''}/static/hero-tomb.png`,
      `${typeof window !== 'undefined' ? window.location.origin : ''}/static/logo.svg`,
    ],
    priceRange: '$$',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'],
        opens: '08:00',
        closes: '17:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Friday',
        opens: '08:00',
        closes: '13:00',
      },
    ],
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: 'HaMasger St 7',
        addressLocality: 'Or Yehuda',
        addressCountry: 'IL',
        addressRegion: 'Center',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Haharoshet 12, Industrial Zone Segula',
        addressLocality: 'Petah Tikva',
        addressCountry: 'IL',
        addressRegion: 'Center',
      },
    ],
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '32.0294',
      longitude: '34.8562',
    },
    areaServed: {
      '@type': 'Country',
      name: 'Israel',
    },
    inLanguage: [language === 'he' ? 'he' : 'en', language === 'he' ? 'en' : 'he'],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default SchemaMarkup;
